const VersionChecker = (url, credentials) => {
    return new Blob([`let timerInterval = 60000,
    timerFunc = () => {
        fetch('${location.protocol}//${location.host}${url}', {
            headers: {
                'Authorization': 'Bearer ${credentials}',
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.status != 200) {throw response.status};
            return response.json();
        })
        .then(data => {
            self.postMessage(data);
        })
        .catch(error => {
            self.close();
        });
};
timerFunc();
setInterval(timerFunc, timerInterval);`], { type: 'text/javascript' });
};

export default VersionChecker;